/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-14 14:27:35
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-14 14:49:15
 * @name: 工单管理-工单详情
 * @Description: 工单管理-工单详情
 * @FilePath: \preSaleNafterSaleInside\project\src\Validator\issue\getVeifyQuality.js
 * @Author: desktop
 */
export const validator = [
  {
    key: 'issue_id',
    description: '工单id',
    required: true,
    required_message: '工单id为必传项',
    match: (e) => {
      return '';
    }
  },
  {
    key: 'run_id',
    description: '后端使用字段',
    required: true,
    required_message: 'run_id为必传项',
    match: (e) => {
      return '';
    }
  },
]